import { render, staticRenderFns } from "./RadioStatBox.vue?vue&type=template&id=6fa525eb&scoped=true&"
import script from "./RadioStatBox.vue?vue&type=script&lang=js&"
export * from "./RadioStatBox.vue?vue&type=script&lang=js&"
import style0 from "./RadioStatBox.vue?vue&type=style&index=0&id=6fa525eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa525eb",
  null
  
)

export default component.exports